import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';

import style from './tooltip-error.module.less';

const TooltipError = ({ className = '', isWarning = false, title = '', content = '' }) => {
  return (
    <div className={classnames(style['shipment-status-icon-tooltip-error'], className, { [style['is-warning']]: isWarning })}>
      <div className={style.title}>
        <FontAwesomeIcon className={style['title-icon']} icon={isWarning ? faExclamationTriangle : faExclamationCircle} />
        <div className={style['title-text']}>{title}</div>
      </div>
      <div className={style.content}>{content}</div>
    </div>
  );
};

TooltipError.propTypes = {
  className: PropTypes.string,
  isWarning: PropTypes.bool,
  title: PropTypes.string,
  content: PropTypes.string,
};

export default TooltipError;
